import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
import img1 from "@/assets/images/friendlink1.png"
import img2 from "@/assets/images/friendlink2.png"
import img3 from "@/assets/images/friendlink3.png"
import img4 from "@/assets/images/friendlink4.png"
import img5 from "@/assets/images/friendlink5.png"
const classnames = classModuleGenerator(styles)
function FriendLinks(props) {
  return (
    <section className={classnames("friendlink-container")}>
      <h3 className={classnames("friendlink-title")}>友情链接</h3>
      <div className="section__inner">
        <ul className={classnames("friendlink-list", "clearfix")}>
        <li>
            <img src={img1} alt="" />
          </li>
          <li>
            <img src={img2} alt="" />
          </li>
          <li>
            <img src={img3} alt="" />
          </li>
          <li>
            <img src={img4} alt="" />
          </li>
          <li>
            <img src={img5} alt="" />
          </li>
        </ul>
      </div>
    </section>
  )
}

export default FriendLinks
